import React, { useEffect, useState,Fragment } from 'react'
import { Card, Col, Container, Form, Row } from 'react-bootstrap'
import BootstrapTable from 'react-bootstrap-table-next'
import { useDispatch, useSelector } from 'react-redux'
import {formato_monto} from '../../../../common/Formatos'

const LiquidacionTotal= () => {
    const data_datos_generales = useSelector((state) => state.casoGeneralReducer)
    const { cfg_form, liquidacionPerdida } = data_datos_generales
  

    return (
    <div>
      <Row>
        <Col>
          <Form.Label
            className='mb-0'
            style={{ fontWeight: 'bold', fontSize: '14px' }}
          >
            {cfg_form.cfg_form['casograldefensa-tab-liqasegpp-mdaindem']}
          </Form.Label>
          <br />
          <Form.Text className='mb-3'>
            {liquidacionPerdida && liquidacionPerdida.length !== 'undefined'
              ? liquidacionPerdida.liquidacionPerdida['glosaMonedaIndeminza']
              : null}
          </Form.Text>
        </Col>
        <Col>
          <Form.Label
            className='mb-0'
            style={{ fontWeight: 'bold', fontSize: '14px' }}
          >
            {cfg_form.cfg_form['casograldefensa-tab-liqasegpp-mtoindem']}
          </Form.Label>
          <br />
          <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
            {liquidacionPerdida && liquidacionPerdida.length !== 'undefined'
              ? formato_monto(liquidacionPerdida.liquidacionPerdida['mtoIndemnizacion'])
              : null}
          </Form.Text>
        </Col>
        <Col>
          <Form.Label
            className=' mb-0'
            style={{ fontWeight: 'bold', fontSize: '14px' }}
          >
            {cfg_form.cfg_form['casograldefensa-tab-liqasegpp-informeliq']}
          </Form.Label>
          <br />
          <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
            {liquidacionPerdida && liquidacionPerdida.length !== 'undefined'
              ?(liquidacionPerdida.liquidacionPerdida['indInformeLiquida']===1?"SI":"NO" )
              : null}
          </Form.Text>
        </Col>
        

        <Col>
          <Form.Label
            className='mb-0'
            style={{ fontWeight: 'bold', fontSize: '14px' }}
          >
            {cfg_form.cfg_form['casograldefensa-tab-liqasegpt-fechinf']}
          </Form.Label>
          <br />
          <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
            {liquidacionPerdida && liquidacionPerdida.length !== 'undefined'
              ? liquidacionPerdida.liquidacionPerdida['fechaInformeFormat']
              : null}
          </Form.Text>
        </Col>
        <Col>
          <Form.Label
            className='mb-0'
            style={{ fontWeight: 'bold', fontSize: '14px' }}
          >
            {cfg_form.cfg_form['casograldefensa-tab-liqasegpt-sitsalva']}
          </Form.Label>
          <br />
          <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
            {liquidacionPerdida && liquidacionPerdida.length !== 'undefined'
              ? liquidacionPerdida.liquidacionPerdida[
                  'sitSalvataje'
                ]
              : null}
          </Form.Text>
        </Col>
      </Row>
      <Row>
        
        <Col>
          <Form.Label
            className='mt-3 mb-0'
            style={{ fontWeight: 'bold', fontSize: '14px' }}
          >
            {cfg_form.cfg_form['casograldefensa-tab-liqasegpt-mdapago']}
          </Form.Label>
          <br />
          <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
            {liquidacionPerdida && liquidacionPerdida.length !== 'undefined'
              ? liquidacionPerdida.liquidacionPerdida[
                  'glosaMonedaPago'
                ]
              : null}
          </Form.Text>
        </Col>

        <Col>
          <Form.Label
            className='mt-3 mb-0'
            style={{ fontWeight: 'bold', fontSize: '14px' }}
          >
            {cfg_form.cfg_form['casograldefensa-tab-liqasegpt-mtopago']}
          </Form.Label>
          <br />
          <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
            {liquidacionPerdida && liquidacionPerdida.length !== 'undefined'
              ? formato_monto(liquidacionPerdida.liquidacionPerdida['mtoPago'])
              : null}
          </Form.Text>
        </Col>
        <Col>
          <Form.Label
            className='mt-3 mb-0'
            style={{ fontWeight: 'bold', fontSize: '14px' }}
          >
            {cfg_form.cfg_form['casograldefensa-tab-liqasegpt-finiquito']}
          </Form.Label>
          <br />
          <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
            {liquidacionPerdida && liquidacionPerdida.length !== 'undefined'
              ? (liquidacionPerdida.liquidacionPerdida['indFiniquito']===1?"SI":"No")
              : null}
          </Form.Text>
        </Col>
        
        <Col>
          <Form.Label
            className='mt-3 mb-0'
            style={{ fontWeight: 'bold', fontSize: '14px' }}
          >
            {cfg_form.cfg_form['casograldefensa-tab-liqasegpt-fechpago']}
          </Form.Label>
          <br />
          <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
            {liquidacionPerdida && liquidacionPerdida.length !== 'undefined'
              ? liquidacionPerdida.liquidacionPerdida['fechaPagoFormat']
              : null}
          </Form.Text>
        </Col>
        
        <Col>
          <Form.Label
            className='mt-3 mb-0'
            style={{ fontWeight: 'bold', fontSize: '14px' }}
          >
            {cfg_form.cfg_form['casograldefensa-tab-liqasegpt-facturavta']}
          </Form.Label>
          <br />
          <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
            {liquidacionPerdida && liquidacionPerdida.length !== 'undefined'
              ? (liquidacionPerdida.liquidacionPerdida['indicaFacturaVenta']===1?"SI":"NO")
              : null}
          </Form.Text>
        </Col>
        
      </Row>
      <Row>
      <Col>
          <Form.Label
            className='mt-3 mb-0'
            style={{ fontWeight: 'bold', fontSize: '14px' }}
          >
            {cfg_form.cfg_form['casograldefensa-tab-liqasegpt-mdaprovi']}
          </Form.Label>
          <br />
          <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
            {liquidacionPerdida && liquidacionPerdida.length !== 'undefined'
              ? liquidacionPerdida.liquidacionPerdida['glosaMonedaProvision']
              : null}
          </Form.Text>
        </Col>
        <Col>
          <Form.Label
            className='mt-3 mb-0'
            style={{ fontWeight: 'bold', fontSize: '14px' }}
          >
            {cfg_form.cfg_form['casograldefensa-tab-liqasegpt-mtoprovi']}
          </Form.Label>
          <br />
          <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
            {liquidacionPerdida && liquidacionPerdida.length !== 'undefined'
              ? formato_monto(liquidacionPerdida.liquidacionPerdida['mtoProvision'])
              : null}
          </Form.Text>
        </Col>
        <Col>
          <Form.Label
            className='mt-3 mb-0'
            style={{ fontWeight: 'bold', fontSize: '14px' }}
          >
            {cfg_form.cfg_form['casograldefensa-tab-liqasegpt-mdasalva']}
          </Form.Label>
          <br />
          <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
            {liquidacionPerdida && liquidacionPerdida.length !== 'undefined'
              ? liquidacionPerdida.liquidacionPerdida['glosaMonedaSalvataje']
              : null}
          </Form.Text>
        </Col>
        <Col>
          <Form.Label
            className='mt-3 mb-0'
            style={{ fontWeight: 'bold', fontSize: '14px' }}
          >
            {cfg_form.cfg_form['casograldefensa-tab-liqasegpt-mtosalva']}
          </Form.Label>
          <br />
          <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
            {liquidacionPerdida && liquidacionPerdida.length !== 'undefined'
              ? formato_monto(liquidacionPerdida.liquidacionPerdida['mtoSalvataje'])
              : null}
          </Form.Text>
        </Col>
        <Col></Col>
      </Row>
    
    </div>
  )
}

export default LiquidacionTotal